import React from 'react';
import { Box } from '@mui/material';
import { useUserAndGameContext } from '../../../contexts/UserAndGameContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import useJoinGameClick from '../../../hooks/general/useJoinGameClick';

const JoinButton = () => {
    const {
        setJoinOpen,
        isUserInThisPool,
        maxEntriesThisPool,
        howManyEntriesInThisPool,
        hasJoinDeadlinePassed,
        masterPoolData,
        gameData
    } = useUserAndGameContext();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    //console.log('JoinButton rendered', "Is Mobile:", isMobile, "isUserInThisPool:", isUserInThisPool, "hasJoinDeadlinePassed:", hasJoinDeadlinePassed);

    const isGameOver = masterPoolData?.gameParameters?.isGameOver;

    const joinGameClick = useJoinGameClick();
    
    // Get textColor from snackbar info
    const textColor = gameData?.gameSnackbarInfo?.textColor;
    
    // If the game is not joinable, return null
    if (masterPoolData?.gameParameters?.notJoinable || isUserInThisPool || isGameOver) {
        return null;
    }

    // User not in pool, deadline not passed - Join Pool +
    if (!isUserInThisPool && !hasJoinDeadlinePassed) {
        return (
            <Box 
                onClick={() => joinGameClick()}
                sx={{
                    backgroundColor: '#FFC60A',
                    borderColor: textColor,
                    borderRadius: '4px',
                    padding: '4px 8px',
                    height: '32px',
                    width: '100px',
                    margin: '24px auto 0px auto',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#1A1C1E',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px',
                    '&:hover': {
                        backgroundColor: 'rgba(255,198,10,0.8)',
                    }
                }}
            >
                Join Pool +
            </Box>
        );
    }
    
    // User not in pool, deadline passed - Pool Closed X
    if (!isUserInThisPool && hasJoinDeadlinePassed) {
        return (
            <Box sx={{
                backgroundColor: '#CC293C',
                border: '1px solid #CC293C',
                borderRadius: '4px',
                padding: '4px 8px',
                height: '32px',
                width: '120px',
                margin: '24px auto 0px auto',
                fontSize: '12px',
                fontWeight: 700,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                opacity: 0.8
            }}>
                Entry Closed ✕
            </Box>
        );
    }
    
    
    return null;
};

export default JoinButton;